module.exports = __webpack_public_path__ + "static/media/icon-tats.95ffaa51.png";